import { render } from "./EnterName.vue?vue&type=template&id=1771364f"
import script from "./EnterName.vue?vue&type=script&lang=js"
export * from "./EnterName.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__